import BookType from "types/BookType";
import classNames from "lib/classNames";
import CoverLink from "components/Cover/CoverLink";
import { BookGroupSizeType, BookPromptContextType } from "../types";

export default function BookGroupPromptItem({
  book,
  context,
  index,
  size,
}: {
  book: BookType;
  context: BookPromptContextType;
  index: number;
  size: BookGroupSizeType;
}) {
  const active = context.activeBook?.id === book.id;

  return (
   
    <div className={classNames(
        index > 8 ? "block md:hidden lg:block" : "",
        index > 10 ? "lg:hidden" : "",
        index > 12 ? "hidden" : ""
    )}>
      <div className="relative group inline-block">
        {!context.hidePosition && index <= 3 && (
          <span
            className={classNames(
              "absolute bottom-0 right-0 z-10",
              "rounded-tl-lg rounded-br-[6px] px-2 py-1 text-sm font-bold",
              index === 1 ? "bg-amber-400 text-gray-800" : "",
              index === 2 ? "bg-gray-600 text-gray-50" : "",
              index === 3 ? "bg-orange-800 text-white" : ""
            )}
          >
            #{index}
          </span>
        )}
        <CoverLink
          book={book}
          size={size === "lg" ? "md" : "sm"}
          variant={active ? "accent" : "none"}
          settings={{
            tooltip: true,
            showStatus: true,
            details: true,
            referrerId: context.referrerId,
          }}
        />
      </div>
    </div>
  );
}
